import { createAction } from '@reduxjs/toolkit';

export interface IEmptyPayload {
  payload: Record<string, never>,
}

export interface ILastPageShiftStepPayload {
  payload: {
    value: number,
  },
}

export const shiftStep = createAction('LAST_PAGE/SHIFT_STEP', (value = 1): ILastPageShiftStepPayload => ({
  payload: {
    value,
  },
}));

interface ILastPageSetStepPayload {
  payload: {
    step: number,
  },
}

export const setStep = createAction('LAST_PAGE/SET_STEP', (step): ILastPageSetStepPayload => ({
  payload: {
    step,
  },
}));

export interface ILastPageSendMessagePayload {
  payload: {
    message: string
    from?: string
  },
}

export const sendMessage = createAction('LAST_PAGE/SEND_MESSAGE', (message: string, from?: string): ILastPageSendMessagePayload => ({
  payload: {
    message: message.trim(),
    from: from?.trim(),
  },
}));

export const showHoliday = createAction('LAST_PAGE/SHOW_HOLIDAY', (): IEmptyPayload => ({
  payload: {},
}));

export const showBirthday = createAction('LAST_PAGE/SHOW_BIRTHDAY', (): IEmptyPayload => ({
  payload: {},
}));

export const remindHoliday = createAction('LAST_PAGE/REMIND_HOLIDAY', (): IEmptyPayload => ({
  payload: {},
}));

export const remindBirthday = createAction('LAST_PAGE/REMIND_BIRTHDAY', (): IEmptyPayload => ({
  payload: {},
}));

export const promoYes = createAction('lastPage/promoYes', (): IEmptyPayload => ({
  payload: {},
}));

export const reset = createAction('LAST_PAGE/RESET', (): IEmptyPayload => ({
  payload: {},
}));
